module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"header-cart-button":{"cart":"Indkøbskurv"}},"de":{"version":1,"header-cart-button":{"cart":"Warenkorb"}},"en":{"header-cart-button":{"cart":"Cart,"}},"fr":{"header-cart-button":{"cart":"Panier"}},"nl":{"header-cart-button":{"cart":"Mandje"}},"pl":{"header-cart-button":{"cart":"Koszyk"}}}')
  delete Component.options._Ctor
}
